<bootstrap-popup [id]="id" [title]="'Exporter en PDF'" [displaySubject]="displaySubject" [modalSize]="'modal-lg'">
	<!-- Modal generation du pdp -->
	<form role="form" class="form-horizontal">
	
		<div class="form-group row section-documents">
		    <div class="col-md-12">
		        <table class="table">
		            <thead>
		                <tr><th>Rappel des document partagés</th></tr>
		            </thead>
		            <tbody class="documents-coches">
						<tr *ngFor="let libelle of documentsCoches">
						    <td>
						        <i class="fa fa-solid fa-check"></i><span class="libelle-doc">{{ libelle }}</span>
						    </td>
						</tr>
		                <tr *ngIf="!documentsCoches.length">
		                    <td>Aucun sélectionné</td>
		                </tr>
		            </tbody>
		        </table>
		    </div>
		</div>
		
		<div class="form-group row section-upload">
		    <ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="dropped($event)" (onFileOver)="fileOver($any($event))" (onFileLeave)="fileLeave($any($event))">
		        <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
		          Glisser / Déposer vos fichiers au format PDF ici
		          <button class="file-selector" type="button" (click)="openFileSelector()">
		          	<i class="fa-regular fa-file-pdf fa-2x text-danger"></i>
		          </button>
		        </ng-template>
		    </ngx-file-drop>
		    <div class="upload-table" *ngIf="annexes.length">
		        <table class="table">
		            <thead>
		                <tr><th>Annexes choisis</th></tr>
		            </thead>
		            <tbody class="upload-name-style">
		                <tr *ngFor="let item of annexes; let i=index">
		                    <td width="40%"><strong>{{ item.relativePath }}</strong></td>
		                    <td width="10%">
		                    	<i class="fa fa-trash fa-2x text-danger" (click)="removeFile(item)"></i>
	                    	</td>
	                    	<td width="50%"></td>
		                </tr>
		            </tbody>
		        </table>
		    </div>
		</div>
		
	</form>
	
	<div class="row">
		<div class="col-md-12">
			<div class="form-group text-center">
				<button type="button" class="btn btn-primary" style="margin-right: 10px" (click)="onCloseRequested()">
					Fermer
				</button>
				<button type="button" class="btn btn-success" data-dismiss="modal" (click)="generatePdf()">
					Générer le PDF
				</button>
			</div>
		</div>
	</div>

</bootstrap-popup>
